import { Store as $store } from '@store';

export const hasUnsavedData = () => $store.getters['app/isLoggedIn'] && $store.state.app.unsavedDataProtection;

// eslint-disable-next-line no-alert
export const unsavedDataConfirm = () => window.confirm('Do you really want to leave? You have unsaved changes!');

/**
 * Tab navigation detection function
 *
 * @param to {Object}
 * @returns {boolean}
 */
const isTabNavigate = (to) => {
  const lastMatch = to.matched[to.matched.length - 1];
  return !!lastMatch.path.match(':tab');
};

export const unsavedRouteGuard = (to, from, next) => {
  if (hasUnsavedData() && !isTabNavigate(to)) {
    if (!unsavedDataConfirm()) {
      next(false);
    } else {
      $store.commit('app/updateUnsavedDataProtection', false);
      next();
    }
  } else {
    next();
  }
};

export const windowUnloadProtection = () => {
  $store.commit('app/updateUnsavedDataProtection', false);
  window.addEventListener('beforeunload', (e) => {
    if (hasUnsavedData()) {
      e.preventDefault();
      e.returnValue = '';
    }
  });
};
